import { render, staticRenderFns } from "./TelegramScopeNotice.vue?vue&type=template&id=bc44645c&scoped=true&"
import script from "./TelegramScopeNotice.vue?vue&type=script&lang=js&"
export * from "./TelegramScopeNotice.vue?vue&type=script&lang=js&"
import style0 from "./TelegramScopeNotice.vue?vue&type=style&index=0&id=bc44645c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc44645c",
  null
  
)

export default component.exports